import { useParams } from "react-router-dom";

export default function useSite() {
  const { site } = useParams<{ site: string }>();
  return site;
}
